'use client';

import { Box, Divider } from '@wishket/design-system';
import { twMerge } from 'tailwind-merge';

import {
  CommentFooter,
  CommentGuide,
  CommentHeader,
} from './CommentTextarea.parts';
import { CommentTextareaProps } from './CommentTextarea.type';

const CommentTextarea = ({
  guideText,
  buttonName,
  disabled,
  userId,
  onSubmit,
  imgUrl,
  isEdit = false,
  onCancel,
  ...rest
}: CommentTextareaProps) => {
  return (
    <Box className="h-fit w-full rounded-xl border border-w-gray-200 bg-w-white">
      <Box
        className={twMerge(
          'box-border flex h-[85px] w-full shrink flex-col gap-2 rounded-t-xl px-4 py-3',
          userId && 'h-[120px]'
        )}
      >
        <CommentHeader userId={userId} imgUrl={imgUrl} />
        {userId && (
          <textarea
            className="h-full w-full text-w-gray-600 outline-none typo-body1 placeholder:text-w-gray-300 placeholder:typo-body1 disabled:bg-w-white"
            spellCheck={false}
            {...rest}
          />
        )}
      </Box>
      <CommentGuide userId={userId} guideText={guideText} />
      <Divider />
      <CommentFooter
        userId={userId}
        isEdit={isEdit}
        onCancel={onCancel}
        onSubmit={onSubmit}
        buttonName={buttonName}
      />
    </Box>
  );
};

export default CommentTextarea;
